<template>
	<modal v-model="open">
		<template #header>
			<h2>Schedule Showroom Visit</h2>
			<p>Select a time that works for your schedule and a dealer representative will call you shortly to confirm your visit.</p>
			<div class="boat__details mt-[37px] relative">
				<div class="boat__reference">
					<b>{{ location?.dealer?.name }}</b><br/>
					{{ location.city }}, {{ location.state }}<br/>
					{{ boat.boat.model_year }} {{ boat.boat.name }}
				</div>
				<div class="boat__image">
					<img :src="image" alt="">
				</div>
			</div>
		</template>
		<loader :loading="loading" class="modal-loader"></loader>
		<form action="" method="post" class="space-y-[24px] mt-5" @submit.prevent="send" v-if="!sent">
			<div class="form__group">
				<input-text v-model="showroom.firstname" label="First Name" :required="true" :errors="errors.firstname"></input-text>
				<input-text v-model="showroom.lastname" label="Last Name" :required="true" :errors="errors.lastname"></input-text>
			</div>
			<div class="form__group">
				<input-text v-model="showroom.email" label="Email" :required="true" :errors="errors.email" inputmode="email"></input-text>
			</div>

			<div class="form__group">
				<input-text v-model="showroom.phone" label="Phone" :required="true" :errors="errors.phone" inputmode="tel" v-mask="'(###) ###-####'"></input-text>
			</div>
			<div>
				<b>Choose a date and time:</b>
			</div>
			<div class="form__group" style="margin-top: 0;">
				<input-text type="date" v-model="showroom.date" :errors="errors.date" label="Date" :required="true" :min="minDate"></input-text>
				<input-text type="time" v-model="showroom.time" :errors="errors.time" label="Time" :required="true" :min="minTime" max="18:00"></input-text>
			</div>

			<div class="form__group">
				<input-textarea label="Special requests for your visit?" v-model="showroom.message" :errors="errors.message"></input-textarea>
			</div>

			<div class="form__group">
				<div class="field__group">
					<input type="submit" value="Schedule Visit" />
				</div>
			</div>
		</form>
		<div class="form__notes text-[12px] mt-8" v-if="!sent">
			By clicking "Submit", you authorize Nauticstar Boats and its dealers to contact you with marketing and sales information by emailing or calling or texting the phone number provided. This authorization is not required to make a purchase, please see our <a href="https://nauticstarboats.com/privacy-policy/" target="_blank">Privacy Policy.</a>
		</div>
		<div v-if="sent" class="space-y-[24px] mt-5 mb-5 success-text">
			 Thank you for your scheduling a showroom visit. We're excited to place you in the perfect Nauticstar boat. Your local certified dealer will confirm your requested visit date and time with you shortly.
		</div>
	</modal>
</template>

<script>
	export default {
		props: ['value', 'boat'],
		data() {
			return {
				open: this.value,
				showroom: {},
				errors: {},
				loading: false,
				sent: false
			};
		},
		computed: {
			minDate() {
				let now = new Date();
				if(now.getHours() >= 2) {
					now.setDate(now.getDate() + 1);
				}
				let years = now.getFullYear();
				let months = now.getMonth() + 1;
				let days = now.getDate();
				return years + '-' + months.toString().padStart(2, '0') + '-' + days.toString().padStart(2, '0');
			},
			minTime() {
				let now = new Date();
				let years = now.getFullYear();
				let months = now.getMonth() + 1;
				let days = now.getDate();
				let n = years + '-' + months.toString().padStart(2, '0') + '-' + days.toString().padStart(2, '0');
				let start = this.showroom.date;
				if(!start) {
					start = this.minDate;
				}
				if(start === n) {
					let hours = now.getHours();
					let minutes = (Math.floor(now.getMinutes() / 15) + 1) * 15;
					if(minutes === 60) {
						hours = hours + 1;
						minutes = 0;
					}
					return hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0');
				}
				return "08:00";
			},
			location() {
				return this.$store.state.location;
			},
			image() {
				if(!this.boat) {
					return '/images/front/BMT.png';
				}
				if(this.boat.featured_image && this.boat.featured_image.thumb600) {
					return this.boat.featured_image.thumb600;
				}
				if(this.boat.boat && this.boat.boat.featured_image && this.boat.boat.featured_image.thumb600) {
					return this.boat.boat.featured_image.thumb600;
				}
				return '/images/front/BMT.png';
			}
		},
		watch: {
			value() {
				this.open = this.value;
			},
			open() {
				this.$emit('input', this.open);
			}
		},
		methods: {
			initShowroom() {
				this.showroom = {
					date: this.minDate,
					time: this.minTime
				};
			},
			async send() {
				this.errors = {};
				this.loading = true;
				try {
					await this.$post('/json/boats/' + this.boat.id + '/showroom', this.showroom);
					this.initShowroom();
					this.sent = true;
				} catch(e) {
					this.errors = e.data || {}
				}
				this.loading = false;
			}
		},
		mounted() {
			this.initShowroom();
		}
	}
</script>